import { ITokenCoin } from '@kattana-io/common';
import BigNumber from 'bignumber.js';
import Image from '../../../../atoms/Image';
import Text from '../../../../atoms/Text';
import { ICoin } from '../../reducers/tradingReducer';

interface FeaturedTokenProps {
    token: ITokenCoin;
    onClick: (token: ICoin) => void;
}

const FeaturedToken = ({ onClick,token }: FeaturedTokenProps) => {
  return (
    <div className='featured__wrapper__token' onClick={() => {
      const coin: ICoin = {
        name: token.symbol || token.name,
        decimals: token.decimals,
        address: token.address,
        symbol: token.name,
        amount: new BigNumber(0),
        balance: 0,
      };

      onClick(coin);
    }}>
      <Text size={12}>{token.symbol}</Text>
      <div className="img_wrapper">
        <Image src={token.coin.logo_url} size='s'></Image>
      </div>
    </div>
  );
};

export default FeaturedToken;